import React, { useState } from 'react'
import Carousel from "react-spring-3d-carousel";
import { v4 as uuidv4 } from "uuid";
import { config } from "react-spring";
import sudhaar from '../assets/Initiatives/event1.jpg';
import gyaan from '../assets/Initiatives/event3.jpg';
import nirmaan from '../assets/Initiatives/event2.png';
import gogreen from '../assets/Initiatives/event4.jpg';
import muskaan from '../assets/Initiatives/event5.jpg';
import '../css/initiatives.css';

const Initiatives = () => {
  const isMobile = window.innerWidth <= 768;
  const [card, setCard] = useState({
    goToSlide: 0,
    offsetRadius: 2,
    showNavigation: true,
    config: config.slow
  });

  const InCards = [
    {
      key: uuidv4(),
      title: "Sudhaar - Reform Initiative",
      content: (
        <div className="card-content">
          <img src={sudhaar} alt="Sudhaar" />
          <div className="text-below">
            <h3>ዓመታዊ በዓል ቅዱስ ዮሃንስ - በመስከረም 1  እንደ ወጉ ይከበራል። በጸሎት ፣ በሃይማኖታዊ ሥርዓትና በባሕላዊ ድግሶች ላይ ትልቅ ስብሰባ ነበር ።</h3>
            <a href="#" target="_blank" rel="noopener noreferrer">ተጨማሪ ያንብቡ</a>
          </div>
        </div> 
      ),
      link: "#"
    },
    {
      key: uuidv4(),
      title: "Gyaan - Knowledge Drive",
      content: (
        <div className="card-content">
          <img src={gyaan} alt="Gyaan" />
          <div className="text-below">
            <h3>ወርሃዊ መንፈሳዊ ጉባዔዎች ኦርቶዶክሳዊ እምነትን ለማስተማር፣ በሃይማኖታዊ ርዕሰ ጉዳዮች ላይ ለመወያየትና መንፈሳዊ እድገት ለማድረግ የተደራጀ ነው።
              መጽሐፍ ቅዱስን ማንበብ፣ መዝሙሮችና ቀሳውስት የሚመሩባቸው ውይይቶችም ይገኙበታል።</h3>
            <a href="#" target="_blank" rel="noopener noreferrer">ተጨማሪ ያንብቡ</a>
          </div>
        </div>
      ),
      link: "#"
    },
    {
      key: uuidv4(),
      title: "Nirmaan - Innovation & Build",
      content: (
        <div className="card-content">
          <img src={nirmaan} alt="Nirmaan" />
          <div className="text-below">
            <h3>ችግረኛ የሆኑ ሰዎችን ለመርዳት ሆስፒታሎችንና ወላጅ አልባ ማሳደጊያዎችን መጎብኘት።</h3>
            <a href="#" target="_blank" rel="noopener noreferrer">ተጨማሪ ያንብቡ</a>
          </div>
        </div>
      ),
      link: "#"
    },
    {
      key: uuidv4(),
      title: "Go Green - Sustainability Project",
      content: (
        <div className="card-content">
          <img src={gogreen} alt="Go Green" />
          <div className="text-below">
            <h3>ጾም እና ጸሎት ስብሰባ - አብይ ፆም ፣ በፊልሴታ እና ሌሎች የጾም ወቅቶች ልዩ ልዩ ስብሰባዎች ይደረጋሉ።
              በጋራ ንሰሀ፣ ጸሎት፣ እና መንፈሳዊ መታደስ ላይ ያተኩራል።</h3>
            <a href="#" target="_blank" rel="noopener noreferrer">ተጨማሪ ያንብቡ</a>
          </div>
        </div>
      ),
      link: "#"
    },
    {
      key: uuidv4(),
      title: "Muskaan - Blood Donation Drive",
      content: (
        <div className="card-content">
          <img src={muskaan} alt="Muskaan" />
          <div className="text-below">
            <h3>የመንፈሳዊ ጉዞዎች - የተደራጀ ጉዞ እንደ አክሱም፣ ላሊበላ፣ ደብረ ዳሞ እና ጽዮን ቅዱስ ማርያም ወዳሉ ቅዱስ ስፍራዎች።
              አባላቱ ታሪካዊ ገዳማትን በመጎብኘት እምነታቸውን እንዲጎበኙ ያበረታታል።</h3>
            <a href="#" target="_blank" rel="noopener noreferrer">ተጨማሪ ያንብቡ</a>
          </div>
        </div>
      ),
      link: "#"
    },
  ].map((slide, index) => {
    return {
      ...slide,
      onClick: () => {
        window.open(slide.link, "_blank");
        setCard({ ...card, goToSlide: index });
      }
    };
  });  

  const onRight = () => {
    setCard({ ...card, goToSlide: card.goToSlide + 1 })
  }

  const onLeft = () => {
    setCard({ ...card, goToSlide: card.goToSlide - 1 })
  }

  return (
    <div className="Initiatives">
      <br />
      <br />
      <div className="title">
        <h1><span>የኛ</span> ክንዋኔዎች</h1>
      </div>
      <div className="initiative-cards">
        <Carousel
          slides={InCards}
          goToSlide={card.goToSlide}
          offsetRadius={card.offsetRadius}
          showNavigation={card.showNavigation}
          animationConfig={card.config}
        />
      </div>

      <div className="arrows">
        <svg onClick={onLeft} xmlns="http://www.w3.org/2000/svg" width={isMobile?"30":"40"} height={isMobile?"30":"40"} fill="currentColor" className="leftarr bi bi-arrow-left-circle-fill" viewBox="0 0 16 16">
          <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
        </svg>
        <svg onClick={onRight} xmlns="http://www.w3.org/2000/svg" width={isMobile?"30":"40"}  height={isMobile?"30":"40"}  fill="currentColor" className="rightarr bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
          <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
        </svg>
      </div>
    </div>
  )
}

export default Initiatives

// import React, { useState, useEffect } from 'react';
// import Carousel from "react-spring-3d-carousel";
// import { v4 as uuidv4 } from "uuid";
// import { config } from "react-spring";
// import '../css/initiatives.css';

// const Initiatives = () => {
//   const isMobile = window.innerWidth <= 768;
//   const [card, setCard] = useState({
//     goToSlide: 0,
//     offsetRadius: 2,
//     showNavigation: true,
//     config: config.slow
//   });
//   const [events, setEvents] = useState([]); // State to store events
//   const [filteredEvents, setFilteredEvents] = useState([]); // State to store filtered events
//   const [eventType, setEventType] = useState('all'); // State to store selected event type
//   const [noEventsMessage, setNoEventsMessage] = useState('');
//   const [startDate, setStartDate] = useState(''); // Start date for filtering
//   const [endDate, setEndDate] = useState(''); // End date for filtering

//   // Fetch events from the API
//   useEffect(() => {
//     fetch('http://localhost:8000/api/events/')  // Change this URL if needed
//       .then(response => response.json())
//       .then(data => {
//         const sortedEvents = data.sort((a, b) => new Date(b.event_date) - new Date(a.event_date)); // Sort by event_date descending
//         setEvents(sortedEvents);  // Store the events in state
//         setFilteredEvents(sortedEvents); // Initially set filtered events to all events
//       })
//       .catch(error => console.error('Error fetching events:', error));
//   }, []);

//   // Filter events based on event type and date range
//   const filterEvents = () => {
//     let filtered = [...events]; // Copy events array to avoid direct mutation

//     // Filter by event type
//     if (eventType !== 'all') {
//       filtered = filtered.filter(event => event.event_type === eventType);
//     }

//     // Filter by start and end dates
//     if (startDate) {
//       filtered = filtered.filter(event => new Date(event.created_at) >= new Date(startDate));
//     }

//     if (endDate) {
//       filtered = filtered.filter(event => new Date(event.created_at) <= new Date(endDate));
//     }

//     // Update the filtered events state
//     setFilteredEvents(filtered);

//     // Check if no events are found and update the message
//     if (filtered.length === 0) {
//       setNoEventsMessage('No events found for the selected filters.');
//     } else {
//       setNoEventsMessage('');
//     }
//   };

//   // Trigger filter when event type, start date or end date changes
//   useEffect(() => {
//     filterEvents();
//   }, [eventType, startDate, endDate]);

//   // Map the filtered events to create cards
//   const InCards = filteredEvents.map(event => ({
//     key: uuidv4(),
//     title: event.title,
//     content: (
//       <div className="card-content">
//         <img src={event.image ? `${event.image}` : ''} alt={event.title} />
//         <div className="text-below">
//           <h3>{event.title}</h3>
//           <a href={event.link || "#"} target="_blank" rel="noopener noreferrer">ተጨማሪ ያንብቡ</a>
//         </div>
//       </div>
//     ),
//     link: event.link || "#"
//   })).map((slide, index) => {
//     return {
//       ...slide,
//       onClick: () => {
//         window.open(slide.link, "_blank");
//         setCard({ ...card, goToSlide: index });
//       }
//     };
//   });

//   const onRight = () => {
//     setCard({ ...card, goToSlide: card.goToSlide + 1 })
//   }

//   const onLeft = () => {
//     setCard({ ...card, goToSlide: card.goToSlide - 1 })
//   }

//   return (
//     <div className="Initiatives">
//       <br />
//       <br />
//       <div className="title">
//         <h1><span>የኛ</span> ክንዋኔዎች</h1>
//       </div>

//       {/* Event Type Dropdown */}
//       <div className="event-type-filter">
//         <select value={eventType} onChange={(e) => setEventType(e.target.value)}>
//           <option value="all">All Events</option>
//           <option value="development">Development</option>
//           <option value="wedding">Wedding</option>
//           <option value="donation">Donation</option>
//           <option value="church_student_donation">Donation to Church Students</option>
//           <option value="singing_service">Singing Service</option>
//         </select>
//       </div>

//       {/* Date Range Filters */}
//       <div className="date-range-filter">
//         <label>Start Date:</label>
//         <input 
//           type="date" 
//           value={startDate} 
//           onChange={(e) => setStartDate(e.target.value)} 
//         />
//         <label>End Date:</label>
//         <input 
//           type="date" 
//           value={endDate} 
//           onChange={(e) => setEndDate(e.target.value)} 
//         />
//       </div>

//       {/* Display the filtered event cards or a message if no events found */}
//       {filteredEvents.length > 0 ? (
//         <div className="initiative-cards">
//           <Carousel
//             slides={InCards}
//             goToSlide={card.goToSlide}
//             offsetRadius={card.offsetRadius}
//             showNavigation={card.showNavigation}
//             animationConfig={card.config}
//           />
//         </div>
//       ) : (
//         <div className="no-events">
//           <p>No events match the selected filter criteria.</p>
//         </div>
//       )}

//       <div className="arrows">
//         <svg onClick={onLeft} xmlns="http://www.w3.org/2000/svg" width={isMobile ? "30" : "40"} height={isMobile ? "30" : "40"} fill="currentColor" className="leftarr bi bi-arrow-left-circle-fill" viewBox="0 0 16 16">
//           <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
//         </svg>
//         <svg onClick={onRight} xmlns="http://www.w3.org/2000/svg" width={isMobile ? "30" : "40"} height={isMobile ? "30" : "40"} fill="currentColor" className="rightarr bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
//           <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
//         </svg>
//       </div>
//     </div>
//   )
// }

// export default Initiatives;
